<template>
  <div>
    <el-form inline>
      <el-form-item label="预约时间">
        <el-date-picker
          v-model="filters.ExpectedTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
      </el-form-item>

      <el-form-item label="状态">
        <el-select v-model="filters.ProportionStatus" multiple="">
          <el-option label="宽松" value="1"></el-option>
          <el-option label="紧张" value="2"></el-option>
          <el-option label="约满" value="3"></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <!--工具条-->
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!--表格-->
    <el-table-bar :fixed="true" :bottom="35">
      <el-table
        :data="tablelist"
        highlight-current-row
        border
        ref="multipleTable"
        v-loading="listLoading"
        @selection-change="selsChange"
        @row-click="handleRowClick"
        style="width: 100%"
      >
        <el-table-column type="selection" width="50"> </el-table-column>
        <el-table-column prop="estimatedDate" width="" label="日期">
        </el-table-column>
        <el-table-column prop="expectedTime" width="" label="时间段">
        </el-table-column>

        <el-table-column prop="deliveryQty" width="" label="箱数">
        </el-table-column>

        <el-table-column prop="deliveryWeight" width="" label="重量">
        </el-table-column>

        <el-table-column prop="deliveryVolume" width="" label="体积cbm">
        </el-table-column>
        <el-table-column prop="proportionDesc" width="" label="状态">
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.proportionStatus == 1 ">宽松</el-tag>
            <el-tag type="warning" v-if="scope.row.proportionStatus == 2 ">紧张</el-tag>
            <el-tag type="danger" v-if="scope.row.proportionStatus == 3 ">约满</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </el-table-bar>

    <TablePaging :page="pager" :query="query"> </TablePaging>
  </div>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import TablePaging from "../../components/TablePaging";
import {
  GetBookingDeliveryReport,
} from "@/api/bookingdelivery.js";

export default {
  components: { Toolbar, TablePaging },
  data() {
    return {
      pager: {
        total: 0,
        pageSize: 50,
        page: 1,
      },
      columns: [],
      buttonList: [],
      sels: [],
      editFormVisible: false,
      flag: false,
      filters: {},
      listLoading: false,
      tablelist: [],
      editForm: {},
      editLoading: false,
      editFormRules: {
      },
    };
  },
  methods: {
    initializeDates() {
      const today = new Date();
      const sevenDaysAgo = new Date(today);
      sevenDaysAgo.setDate(today.getDate() - 15); 

      const sevenDaysAfter = new Date(today);
      sevenDaysAfter.setDate(today.getDate() + 15);

      //this.filters.ExpectedTime=[this.formatDate(sevenDaysAgo),this.formatDate(sevenDaysAfter)];

      this.$set(this.filters, "ExpectedTime", [this.formatDate(sevenDaysAgo),this.formatDate(sevenDaysAfter)]);
    },
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    query(page = 1) {
      
      var para = {};
      // this.filters.page=this.pager.page;
      // this.filters.pageSize=this.pager.pageSize;

      this.newfilters.page = this.pager.page;
      this.newfilters.pageSize = this.pager.pageSize;
      console.info(this.newfilters.ExpectedTime);
      if(this.newfilters.ExpectedTime==null)
      {
        this.$message({
          message: "请输入预约时间",
          type: "error",
        });
        return;
      }

      this.listLoading = true;
      GetBookingDeliveryReport(this.newfilters).then((res) => {
        this.pager.total = res.data.response.total;
        this.tablelist = res.data.response.pageData;
        this.listLoading = false;
      });
    },
    selsChange: function (sels) {
      this.sels = sels;
    },
    //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.flag = !this.flag;
      this.$refs.multipleTable.toggleRowSelection(row, this.flag);
    },
    callFunction(item) {
      // this.filters = {
      //     keyword: item.search
      // };
      // this[item.func].apply(this, item);

      this.$set(this.pager, "page", 1);

      this.newfilters = JSON.parse(JSON.stringify(this.filters));

      this[item.func].apply(this, [item]);
    },
  },
  mounted() {
    //this.query(1);
    this.initializeDates();
    let user = JSON.parse(window.localStorage.user);
    // console.info(user)
    this.typeVisible = user.isSa;

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>

<style>
</style>